export default "__VITE_ASSET__BCQESv3H__"